module.exports = __webpack_public_path__ + "static/media/firework-red.78b84ffc.psd";